import { Anchor, Stack, Title } from "@mantine/core";

import { TextWrapper } from "./components/TextWrapper";
import { SUPPORT_EMAIL } from "./constants/support";

export default function ErrorPage(): JSX.Element {
  return (
    <Stack p="md">
      <Title order={1}>Unexpected Error</Title>
      <TextWrapper>We're sorry, something went wrong.</TextWrapper>
      <TextWrapper>
        Please contact <Anchor href={`mailto:${SUPPORT_EMAIL}`}>support</Anchor> for assistance.
      </TextWrapper>
    </Stack>
  );
}
